// extracted by css-extract-rspack-plugin
export default {"constructorDragContainer":"constructor-drag-container--rnXqlTc7oEY_kG4t"};